
// Gallery side scroller on scroll
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  gsap.registerPlugin(ScrollTrigger);

  var galleries = document.querySelectorAll('.grid.sidescroll-gallery');

  for (var i = 0; i < galleries.length; i++) {
    initHorizontalGallery(galleries[i], i);
  }

  function initHorizontalGallery(grid, index) {
    var viewport = grid.querySelector('.container-fluid');
    var track = grid.querySelector('.row');

    if (!viewport || !track) {
      return;
    }

    function build() {
      var triggerId = 'gallery-horizontal-' + index;
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      gsap.killTweensOf(track);
      gsap.set(track, { clearProps: 'transform' });
      gsap.set(track, { x: 0 });

      var moveAmount = track.scrollWidth - viewport.clientWidth;
      var maxMove = Math.min(moveAmount, 250);

      if (maxMove <= 0) {
        return;
      }

      var initialOffset = 50;

      ScrollTrigger.create({
        id: triggerId,
        trigger: grid,
        start: "top 100%",
        end: "bottom 15%",
        scrub: true,
        invalidateOnRefresh: true,

        onUpdate: function (self) {
          gsap.set(track, {
            x: -(initialOffset + (maxMove - initialOffset) * self.progress),
          });
        },

        onLeaveBack: function () {
          gsap.set(track, { x: 0 });
        },
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});


// Parallax image
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var sections = document.querySelectorAll('.parallax-img');

  for (var i = 0; i < sections.length; i++) {
    initParallaxImage(sections[i], i);
  }

  function initParallaxImage(section, index) {
    var inner = section.querySelector('.inner');
    var img = section.querySelector('.inner img');

    if (!inner || !img) {
      return;
    }

    var triggerId = 'parallax-img-' + index;

    function build() {
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      gsap.killTweensOf(img);
      gsap.set(img, { clearProps: 'transform' });
      gsap.set(img, { y: 0 });

      var moveAmount = Math.round(inner.offsetHeight * 0.1);

      ScrollTrigger.create({
        id: triggerId,
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,

        onUpdate: function(self) {
          gsap.set(img, {
            y: moveAmount - (moveAmount * 2 * self.progress)
          });
        },

        onLeaveBack: function() {
          gsap.set(img, { y: -moveAmount });
        }
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});

// Parallax image background
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var sections = document.querySelectorAll('.parallax-img-bg');

  for (var i = 0; i < sections.length; i++) {
    initParallaxBg(sections[i], i);
  }

  function initParallaxBg(section, index) {
    var inner = section.querySelector('.inner');
    if (!inner) return;

    var bgImage = section.getAttribute('data-bg');

    if (bgImage) {
      section.style.setProperty('--parallax-bg-image', 'url("' + bgImage + '")');
    }

    var triggerId = 'parallax-bg-' + index;

    function build() {
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      var moveAmount = Math.round(inner.offsetHeight * 0.4);
      var baseOffset = -20;

      section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');

      ScrollTrigger.create({
        id: triggerId,
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,

        onUpdate: function(self) {
          var y = baseOffset + moveAmount - (moveAmount * 2 * self.progress);
          section.style.setProperty('--bg-parallax-y', y + 'px');
        },

        onLeaveBack: function() {
          section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');
        }
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});




// New Word Effect .word-effect h1
document.addEventListener('DOMContentLoaded', function() {
  var headings = document.querySelectorAll('.letter-effect h1');

  for (var i = 0; i < headings.length; i++) {
    splitHeading(headings[i]);
  }

  function splitHeading(heading) {
    if (!heading) return;

    var text = heading.textContent || heading.innerText || '';
    var words = text.trim().split(/\s+/);
    var html = '';
    var delayStep = 0.03;
    var letterIndex = 0;
    var i, j, word, char;

    for (i = 0; i < words.length; i++) {
      word = words[i];
      html += '<span class="word">';

      for (j = 0; j < word.length; j++) {
        char = word.charAt(j);
        html += '<span class="char" style="animation-delay:' + (letterIndex * delayStep) + 's;">' + escapeHtml(char) + '</span>';
        letterIndex++;
      }

      html += '</span>';

      if (i < words.length - 1) {
        html += ' ';
        letterIndex++;
      }
    }

    heading.innerHTML = html;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});

// Word effect fade/rise/scale
document.addEventListener('DOMContentLoaded', function() {
  var sections = document.querySelectorAll('.word-effect');

  for (var s = 0; s < sections.length; s++) {
    initWordEffect(sections[s]);
  }

  function initWordEffect(section) {
    var headlines = section.querySelectorAll('.headline');

    for (var i = 0; i < headlines.length; i++) {
      splitHeadingWords(headlines[i]);
    }

    section.classList.add('is-ready');
  }

  function splitHeadingWords(heading) {
    if (!heading) return;

    var text = heading.textContent || heading.innerText || '';
    var words = text.trim().split(/\s+/);
    var html = '';
    var delayStep = 0.16;

    for (var i = 0; i < words.length; i++) {
      html += '<span class="word" style="animation-delay:' + (i * delayStep) + 's;">' + escapeHtml(words[i]) + '</span>';

      if (i < words.length - 1) {
        html += ' ';
      }
    }

    heading.innerHTML = html;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});